import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { UserService } from 'shared/services/User/user.service';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material';
import { InviteFriendsModalComponent } from './invite-friends-modal/invite-friends-modal.component';
import { AppComponent } from 'app/app.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { ViewScheduleComponent } from 'shared/reusable/view-schedule/view-schedule.component';

@Component({
  selector: 'app-waiting-room',
  templateUrl: './waiting-room.component.html',
  styleUrls: ['./waiting-room.component.scss']
})
export class WaitingRoomComponent implements OnInit, OnDestroy {
  loading: boolean;
  groupId: string;
  group: any;
  disableInviteButton: boolean;
  startDraftButtonText: String = 'Wait for group';
  gotReady: Boolean = false;
  task: any;
  imageURL: string = environment.URL_TEAM_IMAGES;

  constructor(
    private data: DataSharingService,
    private router: Router,
    private alertService: AlertPopupService,
    private gs: GroupService,
    private us: UserService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private app: AppComponent
  ) { this.route.queryParams.subscribe(params => { this.groupId = params.groupId; }); }

  ngOnInit() {
    this.loading = true;
    this.data.changeTitle('WAITING ROOM');
    this.refreshRoom();
    this.task = setInterval(() => {
      this.refreshRoom();
    }, 5000);
  }

  goToGroup() {
    this.router.navigateByUrl('/groups');
  }

  refreshRoom() {
    this.gs.refreshGroup(this.groupId).subscribe(response => {
      this.group = response;
      this.updateButtonTexts();
      this.loading = false;
      // Members cant invite people, only leader
      if (response.leader_uid !== this.us.user.uid) {
        this.disableInviteButton = true;
      }
    }, err => {
      this.loading = false;
      this.alertService.errorAlert(err.error.message);
    });
  }

  getJoinedString(joinedStamp) {
    const diff = (Date.now() / 1000) - joinedStamp;
    // show 1 minute default
    if (diff < 60) {
      return String('1 minute ago');
    } else if (diff < 3600) {
      // show every minute til 60
      if (Math.floor(diff / 60) === 1) {
        return String(Math.floor(diff / 60) + ' minute ago');
      } else {
        return String(Math.floor(diff / 60) + ' minutes ago');
      }
    } else if (diff < 86400) {
      // show hours
      if (diff % 60 > 1) {
        return String(Math.floor(diff / 3600) + ' hours ago');
      } else {
        return String(Math.floor(diff / 3600) + ' hour ago');
      }
    } else {
      // 1 day
      if (Math.floor((diff / 86400)) === 1) {
        return String('1 day ago');
      } else {
        // multi days
        return String(Math.floor(diff / 86400) + ' days ago');
      }
    }
  }

  inviteFriends() {
    const dialogRef = this.dialog.open(InviteFriendsModalComponent, {
      width: '300px',
    });
    dialogRef.afterClosed().subscribe(
      data => {
        if (data === true) {
          this.alertService.errorAlertSuccess('Successfully Invited Group Member');
          this.refreshRoom();
        }
      });
  }

  viewPublicListing(){
    this.router.navigate(['/new-group/public-groups/view-detail'],  { queryParams: { groupId: this.groupId } });
  }

  updateButtonTexts() {
    // Group full
    if (Number(this.group.group_member_count) === Number(this.group.group_size)) {
      // Group full - move to scheduler
      this.startDraftButtonText = 'Group is full';
      return this.getReadyForDraft();
    } else {
      // waiting for group members
      const howManyMore = Number(this.group.group_size) - Number(this.group.group_member_count);
      if (howManyMore === 1) {
        this.startDraftButtonText = 'Waiting for ' + howManyMore + ' more group member to join.';
      } else {
        this.startDraftButtonText = 'Waiting for ' + howManyMore + ' more group members to join.';
      }
    }
  }

  getReadyForDraft() {
    clearInterval(this.task);
    // attemp to fix double getReady problem
    if (this.gotReady === false) {
      this.gotReady = true;
      this.router.navigate(['groups/waiting-room/get-ready'], { queryParams: { groupId: this.groupId } });
    }
  }

  sendReminder(contact) {
    contact['reminderSent'] = true;
    this.gs.inviteGroupMemberByPhone(contact, this.groupId).subscribe(res => {
      this.alertService.errorAlertSuccess('Successfully Invited');
    }, err => {
      this.alertService.errorAlertError('Error sending invite. Please check the phone number is valid.');
    });
  }

  ngOnDestroy() {
    clearInterval(this.task);
  }

  viewSchedule() {
    const dialogRef = this.dialog.open(ViewScheduleComponent, {
      data: {
        eventName: this.group.season_ticket.tm_event_name,
        teamImage: this.group.season_ticket.team_thumb_img,
        teamName: this.group.season_ticket.description,
        teamDescription: this.group.season_ticket.description
      },
      width: '70%'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/waiting-room/waiting-room.component.ts